import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import { getRatingsScore } from 'src/store/hotelRating/selectors';
import RatingBadgeContainer from '../../../Hotel/containers/RatingBadge/RatingBadgeContainer';
import { scrollToSectionAction } from '../../store/actions/view';
import { COMPONENT_ID } from '../../constants';

const mapStateToProps = (state) => ({
  value: getRatingsScore(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = (dispatch, { isMobile }) => ({
  onClick: () =>
    dispatch(
      isMobile
        ? scrollToSectionAction(COMPONENT_ID.TRUST_YOU)
        : scrollToSectionAction(COMPONENT_ID.HOTEL_FACTS),
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RatingBadgeContainer);
